<template>
  <div>
    <v-form
      ref="form"
      v-model="valid"      
    >
      <v-container>
        <v-text-field
          v-model="numero"
          placeholder="Ingrese el número de cuenta"
          label="Número de cuenta"
          :rules="rules.numero"
          hint="sugerido 4620 3528 3456 9888"
          prepend-icon="mdi-card-account-details"
          color="primary"
        ></v-text-field>
        <v-text-field
          v-model="descripcion"
          placeholder="Ingrese descripcion de la cuenta"
          label="Descripcion"
          :rules="rules.descripcion"
          prepend-icon="mdi-text-short"
          color="primary"
        ></v-text-field>
        <v-footer>
          <!-- <v-alert
            border="left"
            colored-border
            type="warning"
          >
            A continuación, vamos a crear una nueva cuenta con saldo $ 0,00 y {{ kilosSubsidiados }} kg de gas subsidiados.
          </v-alert> -->
          <!-- <v-spacer></v-spacer> -->
          <v-btn
            :disabled="!updatable"
            color="primary"
            @click="onSubmit"
            :loading="loading"
          >
            Confirmar
          </v-btn>
        </v-footer>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'CuentasCreateComponent',
  data () {
    return {
      valid: false,
      kilosSubsidiados: null
    }
  },
  created () {
    this.kilosSubsidiados = '240.000'
  },
  mounted () {
    if(this.selected && this.selected.id > 0) {
      this.onCuentaClienteId(this.selected.id)
    }
  },
  computed: {
    ...mapGetters('Clientes', ['selected']),
    ...mapGetters('Cuentas', ['edited', 'rules', 'loading', 'updatable']),
    id () {
      return this.edited.id
    },
    numero: {
      get () {
        return this.edited.numero
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          numero: value
        })
      }
    },
    descripcion: {
      get () {
        return this.edited.descripcion
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          descripcion: value
        })
      }
    },
    saldo () {
      return this.edited.saldo
    },
    switchCierre: {
      get () {
        return this.edited.kilos_disponibles
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          kilos_disponibles: value
        })
      }
    },
  },
  watch: {
    selected(newVal) {
      if(newVal && newVal.id > 0) {
        this.onCuentaClienteId(newVal.id)
      }
    }
  },
  methods: {
    ...mapActions('Cuentas', ['onSave', 'onClearEdited', 'onClearSelected']),
    ...mapMutations('Cuentas', ['setEdited']),
    onCuentaClienteId(newVal) {
      this.setEdited({
        ...this.edited,
        cliente_id: newVal
      })
    },
    onSubmit (event) {
      event.preventDefault()
      this.$refs.form.validate()
      if (this.valid) {
        this.onSave().then(response => {
          this.$store.dispatch('CuentasActivas/onFetch');
          this.$store.dispatch('Cuentas/onClearEdited');
          this.$store.dispatch('Cuentas/onClearSelected');
          if(this.selected && this.selected.id > 0) {
            this.onCuentaClienteId(this.selected.id)
          }
          this.$emit('change', false)
        })
      }
    },
    onClose (event) {
      event.preventDefault()
      this.dialog = false
    },
  },
}
</script>
